import { render } from "./klaviyo-sign-up-form.vue?vue&type=template&id=5252d8c8"
import script from "./klaviyo-sign-up-form.vue?vue&type=script&lang=js"
export * from "./klaviyo-sign-up-form.vue?vue&type=script&lang=js"

import "./klaviyo-sign-up-form.vue?vue&type=style&index=0&id=5252d8c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__